/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/view-filter-menu/shop.view-filter-menu.component.ts.
 */
import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ShopViewFilterComponent} from '../view-filter/shop.view-filter.component';
import {MatCheckbox} from '@angular/material/checkbox';
import {ViewFilter} from '../../../../models/view-filter';

/**
 * Zweck: Beschreibt class ShopViewFilterMenuComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    selector: 'shop-view-filter-menu',
    templateUrl: 'shop.view-filter-menu.component.ts.html',
    styleUrls: ['shop.view-filter-menu.component.ts.scss'],
    standalone: false
})
export class ShopViewFilterMenuComponent implements OnInit, OnDestroy {
  @Input() filter: ViewFilter;
  @Output() filterChange = new EventEmitter<ViewFilter>();
  @Output() change = new EventEmitter();
  @Input() filtercomp: ShopViewFilterComponent;

  open = false;

/**
 * Beschreibt Methode clickFilter und ihren Rückgabevertrag.
 */
  clickFilter(filterElement, event) {
    if (filterElement && filterElement.children && filterElement.children.length == 0) {
      event.stopPropagation();
      filterElement.active = !filterElement.active;
      this.doChange();
    }
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.doChange();
  }

/**
 * Beschreibt Methode toggle und ihren Rückgabevertrag.
 */
  toggle() {
    if (this.filter.active) {
      this.filter.active = false;
    } else {
      this.filter.active = true;
    }
    this.doChange();
  }


/**
 * Beschreibt Methode doChangeAll und ihren Rückgabevertrag.
 */
  doChangeAll() {
    if (this.filter.active) {
      this.filter.children.forEach(f => {
        f.active = true;
      });
    } else {
      this.filter.children.forEach(f => {
        f.active = false;
      });
    }
    this.doChange();
  }


/**
 * Beschreibt Methode doChange und ihren Rückgabevertrag.
 */
  doChange(child= null) {
    if (child) {
      this.filter.toggleKnotenId(child.knoten_id);
    }
    this.filter.checkActiveKnoten();
    this.filterChange.emit(this.filter);
    this.change.emit();
  }

/**
 * Beschreibt Methode markFilter und ihren Rückgabevertrag.
 */
  markFilter(event, elem: MatCheckbox) {
    event.stopPropagation();
    elem._onInputClick();
  }
}
